import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import PracticeAreasPage from './pages/PracticeAreasPage';
import PracticeAreaDetailPage from './pages/PracticeAreaDetailPage';
import ConsultationPage from './pages/ConsultationPage';
import PortalPage from './pages/PortalPage';
import ResourcesPage from './pages/ResourcesPage';
import ContactPage from './pages/ContactPage';
import ScrollToTop from './components/ScrollToTop';

function AnimatedRoutes() {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<HomePage />} />
        <Route path="/practice-areas" element={<PracticeAreasPage />} />
        <Route path="/practice-areas/:slug" element={<PracticeAreaDetailPage />} />
        <Route path="/consultation" element={<ConsultationPage />} />
        <Route path="/portal" element={<PortalPage />} />
        <Route path="/resources" element={<ResourcesPage />} />
        <Route path="/contact" element={<ContactPage />} />
      </Routes>
    </AnimatePresence>
  );
}

export default function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="flex flex-col min-h-screen">
        <Navbar />
        <main className="flex-1">
          <AnimatedRoutes />
        </main>
        <Footer />
      </div>
    </Router>
  );
}
